import styled from "styled-components";
import { device } from "../../stylesheet/breakpoints";

type ArticleProps = {
  addition_position_display: number;
};

export const Article = styled.article<ArticleProps>`
  position: relative;
  width: calc(100% + 20px);
  margin: -10px -10px 0 -10px;

  @media ${device.desktop} {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-width: 210px;
    width: 210px;
    border-radius: 5px;

    ${({ addition_position_display }) =>
      addition_position_display === 1
        ? " margin: -10px 0 -10px -10px;"
        : " margin: -10px -10px -10px 0px;"}
  }
`;

export const ArticleContainer = styled.div`
  position: relative;
  width: 100%;
  //height: 100%;
  padding: 30px 20px 20px 20px;

  &::before {
    content: " ";
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    background: rgba(85, 106, 181, 0.15);
    mix-blend-mode: multiply;

    @media ${device.desktop} {
      border-radius: 5px;
    }
  }

  @media ${device.desktop} {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 30px 20px 10px 20px;
    border-radius: 5px;
  }
`;

export const BoxPhoto = styled.div`
  display: flex;
  flex-wrap: nowrap;

  @media ${device.desktop} {
    flex-wrap: wrap;
    margin-bottom: 10px;
  }
`;

export const ThumbaPhoto = styled.div`
  min-width: 40px;
  width: 40px;
  height: 40px;
  margin-right: 10px;
  border-radius: 5px;
  overflow: hidden;

  @media ${device.desktop} {
    margin-bottom: 20px;
  }
`;

export const Photo = styled.img`
  display: block;
  height: 100%;
  width: 100%;
  object-fit: cover;
  object-position: center center;
`;

export const FlexBox = styled.div`
  @media ${device.desktop} {
    display: inline-flex;
    flex-direction: column;
  }
`;

export const TitlePhoto = styled.h2`
  margin: 0;
  margin-bottom: 2px;
  font-weight: 700;
  font-size: 13px; //11
  line-height: 1.45;
  color: var(--title-text-color);

  @media ${device.desktop} {
    margin-top: 4px;
    margin-bottom: 0;
    font-size: 12px;
    line-height: 1.33;
  }
`;

export const LabelPhoto = styled.span`
  font-weight: 400;
  font-size: 9px;
  line-height: 1.78;
  color: var(--text-color);
`;

export const TextPhoto = styled.p`
  width: 100%;
  font-weight: 400;
  font-size: 12px; //10
  line-height: 1.3;
  color: var(--text-color);

  @media ${device.desktop} {
    position: relative;
    padding: 10px;
    font-size: 11px; //9
    line-height: 1.56;
    background: rgba(85, 106, 181, 0.05);
    /* mix-blend-mode: multiply; */
    border-radius: 5px;

    &::after {
      content: " ";
      position: absolute;
      top: -19px;
      left: 10px;
      border: 10px solid transparent;
      border-bottom: 9px solid rgba(85, 106, 181, 0.05);
      mix-blend-mode: multiply;
    }
  }
`;

type BonusProps = {
  design_type?: number;
};

export const BoxBonuse = styled.div<BonusProps>`
  @media ${device.desktop} {
    width: 100%;
  }
`;
